export default __webpack_public_path__ + "static/media/team-photo3.12c675e8.jpg";